import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const LandingPageIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.15918 5.82007C4.95207 5.82007 4.78418 5.98796 4.78418 6.19507V12.4081C4.78418 12.6152 4.95207 12.7831 5.15918 12.7831H11.3722C11.5793 12.7831 11.7472 12.6152 11.7472 12.4081V6.19507C11.7472 5.98796 11.5793 5.82007 11.3722 5.82007H5.15918ZM5.53418 11.8768V6.57007H10.9972V11.9972L8 9L5.53418 11.8768Z"
          fill="#F7F9FD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 0.625C1.62598 0.625 1.27345 0.78526 1.0181 1.06025C0.763614 1.33431 0.625 1.70045 0.625 2.07692V13.9231C0.625 14.2996 0.763614 14.6657 1.0181 14.9397C1.27345 15.2147 1.62598 15.375 2 15.375H13.9645C14.7435 15.375 15.375 14.7435 15.375 13.9645V2.07692C15.375 1.70045 15.2364 1.33431 14.9819 1.06025C14.7266 0.78526 14.374 0.625 14 0.625H2ZM1.56769 1.57059C1.68741 1.44166 1.84358 1.375 2 1.375H14C14.1564 1.375 14.3126 1.44166 14.4323 1.57059C14.5529 1.70046 14.625 1.88216 14.625 2.07692V3.2334H1.37508L1.375 2.07692C1.375 1.88216 1.4471 1.70046 1.56769 1.57059ZM1.375 3.9834V13.9231C1.375 14.1178 1.4471 14.2995 1.56769 14.4294C1.68741 14.5583 1.84359 14.625 2 14.625H13.9645C14.3293 14.625 14.625 14.3293 14.625 13.9645V3.9834H1.375Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
